import { render } from "./AddPrixProduitCondTypeClient.vue?vue&type=template&id=26572e46&scoped=true&ts=true"
import script from "./AddPrixProduitCondTypeClient.vue?vue&type=script&lang=ts"
export * from "./AddPrixProduitCondTypeClient.vue?vue&type=script&lang=ts"

import "./AddPrixProduitCondTypeClient.vue?vue&type=style&index=0&id=26572e46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26572e46"]])

export default __exports__